module.exports = __webpack_public_path__ + "icon_question_circle_lightgray.e3df6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/icon_question_circle_lightgray.svg
// module id = ./src/_asset/sources/assets/images/@svg/icon_question_circle_lightgray.svg
// module chunks = main